import { useState as i, useEffect as r } from "react";
function d() {
  const [u, e] = i(!0);
  return r(() => {
    function s(n) {
      return n.querySelector(".popup-content") == null;
    }
    function t(n) {
      s(n.target) && e(!1);
    }
    function o() {
      setTimeout(() => e(!0));
    }
    return window.document.addEventListener("mousedown", t), window.document.addEventListener("mouseup", o), () => {
      window.document.removeEventListener("mousedown", t), window.document.removeEventListener("mouseup", o);
    };
  }, [e]), u;
}
export {
  d as default
};
